import {get} from "../modules/ajax";
import {hideModalLoader, openModalFromHtml, showModal, showModalLoader} from "./modal";
import {getImageSizeFromUrl} from "./image";
import {hideElement, showElement} from "./element-visibility";
import {isDesktop, isIOS} from "../modules/devices";
import PinchZoom from "pinch-zoom-js";
import EmblaCarousel from "embla-carousel";
import {createCarousel} from "./carousel";

const $body = document.querySelector('body');
const $html = document.querySelector('html');
let scrollPosition = 0;

let mainSlider = null;
let thumbnailSlider = null;
let useNativeZoom = false;

export function addIOSWindowFix()
{
    $html.style.height = 'calc(100vh - 1px)';
    scrollPosition = window.pageYOffset;
    $body.style.overflowY = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `-${scrollPosition}px`;
    $body.style.width = '100%';
}

export function clearIOSWindowFix()
{
    $body.style.removeProperty('overflowY');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
    $html.style.removeProperty('height');
}

export function showImageZoomPopup(productId, position)
{
    if (!isDesktop() && isIOS()) addIOSWindowFix();

    let modal = document.getElementById('modal-image-zoom');
    if (modal) {
        showModalLoader(modal);
        if (modal.dataset.productId === productId) {
            if (isDesktop()) removeZoomOfAllDesktopImages();
            hideModalLoader(modal);
            setTimeout(function() {
                if (mainSlider) mainSlider.scrollTo(position);
            }, 200);
        } else {
            getModalImageZoom(productId, true, position);
        }
        showModal('modal-image-zoom');
        if (!isDesktop()) setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
        }, 200);
    } else {
        getModalImageZoom(productId, false, position);
    }
}

let ajaxModal = null;
function getModalImageZoom(productId, onlyContent, position)
{
    if (ajaxModal) ajaxModal.abort();
    ajaxModal = get(
        '/ajax/website/product/get-modal-image-zoom',
        {
            productId: productId,
            onlyContent: onlyContent,
        },
        function(response) {
            ajaxModal = null;
            if (onlyContent) {
                let modal = document.getElementById('modal-image-zoom');
                modal.dataset.productId = productId;
                modal.querySelector('#modal-image-zoom-content').innerHTML = response.modal;
                hideModalLoader(modal);
            } else {
                openModalFromHtml(response.modal, {}, false);
            }
            setTimeout(function() {
                destroySliders();
                loadMainSlider();
                loadThumbnailSlider();
                loadMobileZoom();
                if (mainSlider) {
                    if (useNativeZoom) {
                        mainSlider.scrollTo(position, true);
                    } else {
                        mainSlider.scrollTo(position);
                    }
                }
            }, 200);
        },
        function () {
            ajaxModal = null;
        }
    );
}

export async function zoomImage(element, isZoomed)
{
    let image = element.querySelector('img');
    let slider = element.closest('.product-zoom-carousel__viewport')
        || element.closest('.product-zoom-carousel')
        || element.closest('.embla-carousel');
    if (!slider || !image) {
        return;
    }

    let imageSize = await getImageSizeFromUrl(image.src);
    let width = imageSize.width;
    let height = imageSize.height;
    let margin = 50;
    let minWidth = slider.offsetWidth + margin;
    let minHeight = slider.offsetHeight + margin;

    if (width <= minWidth && height <= minHeight) element.style.backgroundSize = 'cover';
    if (isZoomed) {
        element.classList.add('zoomed');
        element.style.backgroundImage = `url('${image.src}')`;
        element.style.backgroundRepeat = 'no-repeat';
        hideElement(image);
        element.onmousemove = function(event) {
            moveImage(event);
        };
    } else {
        element.classList.remove('zoomed');
        element.style.backgroundImage = '';
        element.style.backgroundRepeat = '';
        setTimeout(function() {
            showElement(image);
        }, 15);
    }
}

function moveImage(e)
{
    let imageZoom = e.currentTarget;
    let offsetX = e.offsetX || null;
    let offsetY = e.offsetY || null;
    if (!offsetX || !offsetY) return;
    let x = offsetX / imageZoom.offsetWidth * 100;
    let y = offsetY / imageZoom.offsetHeight * 100;
    imageZoom.style.backgroundPosition = x + '% ' + y + '%';
}

function loadMobileZoom()
{
    if (isDesktop()) return;
    let images = document.querySelectorAll('#modal-image-zoom .main-slider .touch-zoom');
    let navigationTimeout;
    images.forEach(function(image) {
        new PinchZoom(image, {
            onZoomStart: function() {
                if (!mainSlider) return;
                if (useNativeZoom) {
                    mainSlider.setAllowSwipe(false);
                } else {
                    mainSlider.reInit({watchDrag: false});
                }
            },
            onZoomUpdate: function(object) {
                if (!mainSlider) return;
                if (useNativeZoom) {
                    mainSlider.setAllowSwipe(false);
                } else {
                    mainSlider.reInit({watchDrag: false});
                }
                clearTimeout(navigationTimeout);
                navigationTimeout = setTimeout(function() {
                    let allowNavigation = object.zoomFactor === 1;
                    if (useNativeZoom) {
                        mainSlider.setAllowSwipe(allowNavigation);
                    } else {
                        mainSlider.reInit({watchDrag: allowNavigation});
                    }
                }, object.options.animationDuration + 150);
            },
            draggableUnzoomed: false
        });
    });
}

export function removeZoomOfAllDesktopImages()
{
    let images = document.querySelectorAll('#modal-image-zoom .main-slider .desktop-zoom');
    images.forEach(function(image) {
        zoomImage(image, false);
    });
}

function destroySliders()
{
    if (mainSlider && typeof mainSlider.destroy === 'function') {
        mainSlider.destroy();
    }
    if (thumbnailSlider && typeof thumbnailSlider.destroy === 'function') {
        thumbnailSlider.destroy();
    }
    mainSlider = null;
    thumbnailSlider = null;
}

function loadMainSlider()
{
    const nativeRoot = document.querySelector('#modal-image-zoom .product-zoom-carousel.main-slider');
    if (nativeRoot) {
        useNativeZoom = true;
        mainSlider = createCarousel(nativeRoot, {
            selectors: {
                viewport: '.product-zoom-carousel__viewport',
                track: '.product-zoom-carousel__track',
                slide: '.product-zoom-carousel__slide',
                prev: '.product-zoom-carousel__prev',
                next: '.product-zoom-carousel__next'
            },
            loop: false,
            mode: 'percent',
            slidesPerView: 1,
            startIndex: 0,
            swipe: true,
            suppressClickOnSwipe: true,
            arrows: {mode: 'toggle-hidden'},
            watchResize: true,
            thumbnails: '#modal-image-zoom .product-zoom-thumbs__slide',
            onSelect: function(index) {
                if (thumbnailSlider) {
                    thumbnailSlider.scrollTo(index, false);
                }
            }
        });
        return;
    }

    useNativeZoom = false;
    let slider = document.querySelector('#modal-image-zoom .main-slider');
    if (!slider) return;
    let emblaPrevButton = slider.querySelector('.embla-prev-button');
    let emblaNextButton = slider.querySelector('.embla-next-button');
    mainSlider = EmblaCarousel(slider.querySelector('.embla-carousel'));

    if (mainSlider.canScrollPrev()) emblaPrevButton.classList.remove('d-none');
    if (mainSlider.canScrollNext()) emblaNextButton.classList.remove('d-none');

    emblaPrevButton.addEventListener('click', mainSlider.scrollPrev, false);
    emblaNextButton.addEventListener('click', mainSlider.scrollNext, false);

    mainSlider.on('select', function() {
        if (mainSlider.canScrollPrev() && emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.remove('d-none');
        if (!mainSlider.canScrollPrev() && !emblaPrevButton.classList.contains('d-none')) emblaPrevButton.classList.add('d-none');
        if (mainSlider.canScrollNext() && emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.remove('d-none');
        if (!mainSlider.canScrollNext() && !emblaNextButton.classList.contains('d-none')) emblaNextButton.classList.add('d-none');
    });
}

function loadThumbnailSlider()
{
    const nativeRoot = document.querySelector('#modal-image-zoom .product-zoom-thumbs.thumbnail-slider');
    if (nativeRoot) {
        thumbnailSlider = createCarousel(nativeRoot, {
            selectors: {
                viewport: '.product-zoom-thumbs__viewport',
                track: '.product-zoom-thumbs__track',
                slide: '.product-zoom-thumbs__slide'
            },
            loop: false,
            mode: 'offset',
            slidesPerView: 1,
            startIndex: 0,
            swipe: true,
            suppressClickOnSwipe: false,
            arrows: {mode: 'toggle-hidden'},
            watchResize: true
        });
        return;
    }

    let slider = document.querySelector('#modal-image-zoom .thumbnail-slider');
    if (!slider || !mainSlider) return;
    let thumbnails = slider.querySelectorAll('.embla-slide');
    thumbnailSlider = EmblaCarousel(slider, {slidesToScroll: 'auto', dragFree: true});

    mainSlider.on('init', function() {
        thumbnails[mainSlider.selectedScrollSnap()].classList.add('active');
    });

    mainSlider.on('select', function() {
        let index = mainSlider.selectedScrollSnap();

        thumbnailSlider.scrollTo(index);
        thumbnails.forEach((thumbnail) => thumbnail.classList.remove('active'));
        thumbnails[index].classList.add('active');
    });

    thumbnails.forEach(function(thumbnail, index) {
        thumbnail.addEventListener('click', function() {
            mainSlider.scrollTo(index);
            thumbnails.forEach((thumb) => thumb.classList.remove('active'));
            thumbnails[index].classList.add('active');
        });
    });
}
